// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { defineMessages } from "react-intl";

export const messages = defineMessages({
    errorUrlType: {
        id: "apps.lensCta.validation.errorUrlType",
        description: "Error url type.",
        defaultMessage: "Please provide a valid URL",
    },
    errorUriPattern: {
        id: "apps.lensCta.validation.errorUriPattern",
        description: "Error uri pattern.",
        defaultMessage: "Link must be a valid Deep Link",
    },
    errorIosAppId: {
        id: "apps.lensCta.validation.errorIosAppId",
        description: "Error ios app id.",
        defaultMessage: "iOS App ID must be a number",
    },
    errorAndroidAppUrlPattern: {
        id: "apps.lensCta.validation.errorAndroidAppUrlPattern",
        description: "Error android app url pattern.",
        defaultMessage: "Please provide a valid AndroidAppUrl",
    },
});
